<template>
  <div class="wrapper">
    <!--头部-->
    <div class="header-wrapper">
      <div class="left" @click="goback">
        <div class="iconfont icon-fanhui2" style="font-size:35px"></div>
      </div>
      <div class="header">{{info.name}}</div>
    </div>
    <!--组织信息-->
    <org-info class="mar-btm" :old-info="info" ref="info"></org-info>
    <!--成员信息-->
    <org-member class="mar-btm" :comeType="comeType" :id="id" :communityId="communityId"></org-member>
    <!--相册-->
    <org-album class="mar-btm" :comeType="comeType" :id="id"></org-album>
    <!--活动-->
    <org-active :comeType="comeType" :id="id"></org-active>
  </div>
</template>

<script>
  import orgInfo from './orgComponents/orgInfo'
  import orgMember from './orgComponents/orgMember'
  import orgAlbum from './orgComponents/orgAlbum'
  import orgActive from './orgComponents/orgActive'

  export default {
    name: 'organizeDetail',
    components: {
      orgInfo,
      orgMember,
      orgAlbum,
      orgActive
    },
    data() {
      return {
        id: '',//组织id
        communityId: '',
        info: {
          pic: '',
          name: '',
          remark: '',
        },
        comeType: ''
      }
    },
    methods: {
      getInfo() {
        let orgDetail = this.getOrgDetail()
        Promise.all([orgDetail]).then(res => {
          var info = res[0].rows[0]
          this.info = {
            pic: info.headPicUrl?{
              path:info.headPicUrl
            }:'',
            name: info.orgName || '',
            remark: info.remark || '',
            userName: info.userName || '',
            userPhoneNO: info.userPhoneNO || '',
            address: info.address || '',
            coordinate: info.coordinate || ''
          }
        })
      },
      getOrgDetail() {
        var url = this.urlobj.getOrgDetail
        return this.$post(url, {
          id: this.id,
          communityId: this.communityId,
          comeType: this.comeType
        })
      },
      goback() {
        this.$router.go(-1)
      },
    },
    mounted() {
      this.id = this.$route.query.id.toString()
      this.communityId = this.$route.query.communityId
      this.comeType = this.$route.query.type
      this.getInfo()
    }
  }
</script>

<style scoped lang="less">
  .wrapper {
    padding-bottom: 60px;
  }

  .header-wrapper {
    display: flex;
    line-height: 30px;
    padding: 30px 0;
    justify-content: center;
    position: relative;
    .header {
      font-size: 25px;
      text-align: center;
    }
  }

  .mar-btm {
    margin-bottom: 20px;
  }
  /* 返回 */
  .left {
    position: absolute;
    left: 20px;
    font-size: 22px;
  }
</style>
